module.exports = __webpack_public_path__ + "static/UNITY-SQUARE-Two-traditional_v2-en-9c2f073a6538901d2ea2988e47ea6d0a.pdf";